import router from '../../router';

const state = {
	
	/**
	 * IDトークン (未認証 = null)
	 */
	idToken: null,
	
	/**
	 * IDトークンを管理するセッションストレージのキー名
	 */
	stgKeyIdToken: 'IdToken',
	
	/**
	 * RememberMeトークンを管理するローカルストレージのキー名
	 */
	stgKeyRememberMeToken: 'RememberMeToken',
	
	/**
	 * RememberMeトークンの有効期限を管理するローカルストレージのキー名
	 */
	stgKeyRememberMeExpiresIn: 'RememberMeExpiresIn',
	email: '',
	password: '',
	message: '',
};

const getters = {
	idToken: state => state.idToken,
	strKeyIdToken: state => state.stgKeyIdToken,
	strKeyRememberMeToken: state => state.stgKeyRememberMeToken,
	strKeyRememberMeExpiresIn: state => state.stgKeyRememberMeExpiresIn,
	message: state => state.message,
};

const mutations = {
	setEmail(state, email) {
		state.email = email;
	},
	setPassword(state, password) {
		state.password = password;
	},
	setIdToken(state, idToken) {
		state.idToken = idToken;
	},
	message(state, message) {
		state.message = message;
	},
};

const actions = {
	
	/**
	 *
	 * @param getters
	 * @param commit
	 */
	check({getters, commit, dispatch}) {
		// セッションストレージの IDトークン を取得
		const idToken = sessionStorage.getItem(getters.strKeyIdToken);
		
		// セッションストレージに認証トークンIDが有る時は、Vuexに設定
		if (idToken) {
			commit('setIdToken', idToken);
			return false;
		}
		
		// Remember-meトークン を ローカルストレージから取得
		const rememberMeToken    = localStorage.getItem(getters.strKeyRememberMeToken);
		// Remember-me認証有効期限 を ローカルストレージから取得
		const rememberMeExpireIn = localStorage.getItem(getters.strKeyRememberMeExpiresIn);
		
		// ローカルストレージにRemember-meトークン及び有効期限のデータが有る時は、Remember-me認証の検証を行う。
		if (!idToken && rememberMeToken && rememberMeExpireIn) {
			dispatch('doVerifyRememberMe', {rememberMeToken, rememberMeExpireIn});
			return false;
		}
		
		// ストレージ内を全てクリア。ゴミが残っている可能性を排除。
		sessionStorage.clear();
		localStorage.clear();
		
		// ブラウザのタブの切り替えによる、認証状態の持続がされなかった場合。（セッションストレージの特性）
		// サーバー側を確認して認証状態の場合は、IDトークンを取得。
		dispatch('doReVerifyId');
		
	},
	
	doVerifyRememberMe({getters, commit, dispatch}, {rememberMeToken, rememberMeExpireIn}) {
		
		/* 有効期限が切れていないか */
		const expireUTCDate    = new Date(rememberMeExpireIn);
		const offset           = -1 * expireUTCDate.getTimezoneOffset() * 60 * 1000;
		const expireLocalTime  = expireUTCDate.getTime() + offset;
		const currentLocalTime = new Date().getTime();
		// 有効期限が切れていたら:true
		const isExpired        = currentLocalTime >= expireLocalTime;
		
		// 有効期限が切れていたら。。。ローカルストレージないのデータを削除。
		if (isExpired) {
			localStorage.removeItem(getters.strKeyRememberMeToken);
			localStorage.removeItem(getters.strKeyRememberMeExpiresIn);
			return false;
		}
		/* \END 有効期限が切れていないか */
		
		let formData = new FormData();
		formData.append('type', 'authenticate');
		formData.append('action', 'remember-me');
		formData.append('remember-me-token', rememberMeToken);
		dispatch('ajaxVerify', formData);
	},
	
	doVerifyId({commit, dispatch}, formDataElm) {
		let formData = new FormData(formDataElm);
		formData.append('type', 'authenticate');
		formData.append('action', 'normal');
		formData.append('location', '/membership');
		dispatch('ajaxVerify', formData);
	},
	
	doReVerifyId({dispatch}) {
		let formData = new FormData();
		formData.append('type', 'authenticate');
		dispatch('ajaxVerify', formData);
	},
	
	ajaxVerify({dispatch}, formData) {
		fetch(HOME_URL + '/ajax/member.php', {
			method: 'POST',
			body: formData,
		})
			.then(response => {
				if (response.ok) {
					return response.json();
				}
			})
			.then(result => {
				console.log('IDトークン: ' + result['id_token']);
				console.log('RememberMeトークン: ' + result['remember_me_token']);
				console.log('RMトークン有効期限' + result['remember_me_expires_in']);
				
				if (!result['id_token']) {
					console.log('Auth Failed...');
					console.log(result);
					dispatch('authFailed', result);
					return;
				}
				
				console.log('Auth Successful!!');
				console.log(result);
				dispatch('authSuccessful', result);
			})
			.catch(error => {
				console.log(error);
			})
	},
	
	/**
	 * 認証成功
	 *
	 * @param getters
	 * @param commit
	 * @param dispatch
	 * @param authData
	 */
	authSuccessful({getters, commit, dispatch}, authData) {
		console.log('authSuccessfulメソッド実行');
		// vuexにセット
		commit('setIdToken', authData['id_token']);
		// セッションストレージにセット。
		sessionStorage.setItem(getters.strKeyIdToken, authData['id_token']);
		
		if (authData['remember_me_token'] && authData['remember_me_expires_in']) {
			// ローカルストレージにセット
			localStorage.setItem(getters.strKeyRememberMeToken, authData['remember_me_token']);
			localStorage.setItem(getters.strKeyRememberMeExpiresIn, authData['remember_me_expires_in']);
		}
		
		// 画面遷移
		if (authData['location']) {
			router.push('/membership');
		}
	},
	
	/**
	 * 認証失敗
	 */
	authFailed({commit}) {
		console.log('authFailedメソッド実行');
		commit('message', 'IDまたはパスワードが違います。');
	},
	
	/**
	 * サインアウト
	 */
	signOut({getters, commit}) {
		let formData = new FormData();
		formData.append('type', 'sign-out');
		fetch(HOME_URL + '/ajax/member.php', {
			method: 'POST',
			body: formData,
		})
			.then(response => {
				if (response.ok) {
					return response.json();
				}
			})
			.then(result => {
				console.log(result.signOut);
				// vuexの認証トークン削除 削除
				commit('setIdToken', null);
				// セッションストレージの認証トークン削除
				sessionStorage.removeItem(getters.strKeyIdToken);
				// ローカルストレージの自動認証トークン削除
				localStorage.removeItem(getters.strKeyRememberMeToken);
				localStorage.removeItem(getters.strKeyRememberMeExpiresIn);
				
				if (result.signOut) {
					router.push('/');
				}
			});
	},
	
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}